import { Box, Container } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import { StyledButton, Title } from './styles';
// import { Container } from './styles';

const Home: React.FC = () => {
  return (
    <>
      <Header active="Home" />
      <Container style={{backgroundColor:'rgba(255,255,255,0.8)', height:'80vh'}} maxWidth="sm">
        <Title>Bem-Vindo(a)!</Title>
        <Box sx={{display:'flex', flexWrap:'wrap',justifyContent:'center'}}>
          <p style={{textAlign:'center'}}>Por favor, escolha um tipo de sessão</p>
          <Link style={{color: 'inherit', textDecoration: 'inherit', width: '100%'}} to='/AgendamentoPresencial'>
            <StyledButton style={{width: '100%'}}>
                Sessão Presencial
            </StyledButton>
          </Link>
            <Link style={{color: 'inherit', textDecoration: 'inherit',width: '100%'}} to='/AgendamentoVirtual'>
            <StyledButton style={{width: '100%'}}>
              Sessão Virtual
            </StyledButton>
          </Link>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default Home;
